import tw from "tailwind-styled-components"

export const Section = tw.div`
flex
flex-col
items-center
justify-center
gap-5
mb-9
pb-9
md:mb-16
md:pb-16
lg:mb-20
lg:pb-20
relative
`

export const Title = tw.h1`
mt-0
sm:mt-0
text-4xl
sm:text-4xl
md:text-5xl
lg:text-7xl
font-medium
md:!leading-tight
bg-clip-text
text-transparent bg-gradient-to-br from-white to-grayscale-lightest
max-w-[500px]
md:max-w-[800px]
lg:max-w-[1000px]
`

export const Subtitle = tw.p`
text-grayscale-lightest
text-xl
sm:text-xl
md:text-2xl
max-w-[390px]
sm:max-w-[520px]
md:max-w-[600px]
leading-snug
sm:leading-normal
px-1
sm:px-0
`

export const Heading = tw.p`
text-white
text-2xl
md:text-2xl
lg:text-3xl
max-w-[600px]
mb-2
px-2
md:px-0
`

export const LargeHeading = tw.p`
text-white
text-3xl
md:text-4xl
lg:text-5xl
leading-tight
lg:leading-normal
lg:mb-1
mb-1
px-2
md:px-0
`

export const Paragraph = tw.p`
text-white
text-opacity-50
text-xl
md:text-2xl
max-w-[570px]
leading-normal
px-2
md:px-0
`

export const Spacer = tw.div`
h-3
sm:h-8
md:h-9
lg:h-10
`

export const Card = tw.div`
  overflow-hidden
  rounded-[30px]
  py-0
  px-16
  border-white
  border-2
  mx-auto
  my-3
  bg-grayscale-lightest bg-opacity-10 border border-white border-1 border-opacity-10 shadow-2xl
`

export const AppIcons = [
  {
    url: "https://is2-ssl.mzstatic.com/image/thumb/Purple116/v4/e6/ac/af/e6acaf67-e34e-c62d-b765-ea9525ed1d73/AppIcon-1x_U007emarketing-0-7-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is2-ssl.mzstatic.com/image/thumb/Purple116/v4/93/41/d9/9341d9eb-3c70-b000-01c2-1985e2fd8714/AppIcon-AppStore-0-1x_U007emarketing-0-10-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is3-ssl.mzstatic.com/image/thumb/Purple126/v4/47/0c/98/470c98d9-e533-350d-e58d-6b26f22d760b/AppIcon-1x_U007emarketing-0-7-0-85-220.png/256x256bb.jpg",
  },
  {
    url: "https://is4-ssl.mzstatic.com/image/thumb/Purple116/v4/38/9a/57/389a5705-a069-cbf7-b32e-1aac31becaa2/AppIcon-1x_U007emarketing-0-7-0-sRGB-0-85-220.png/256x256bb.jpg",
  },
  {
    url: "https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/09/46/d1/0946d117-56a7-dfc3-7f2c-9be428568852/AppIcon-0-1x_U007emarketing-0-7-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is3-ssl.mzstatic.com/image/thumb/Purple116/v4/50/85/b3/5085b37f-5c72-abc7-18e6-e7d1ddc3e822/AppIcon-Prod-0-1x_U007emarketing-0-7-0-sRGB-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is5-ssl.mzstatic.com/image/thumb/Purple116/v4/a5/8b/12/a58b123b-f09d-9e9b-5ccb-a47221b3e2de/AppIcon-1x_U007emarketing-0-7-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is2-ssl.mzstatic.com/image/thumb/Purple113/v4/b8/54/44/b8544449-aa21-d6d0-dd76-9d1450b4896c/AppIcon-0-1x_U007emarketing-0-7-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is2-ssl.mzstatic.com/image/thumb/Purple123/v4/27/7c/e9/277ce9dc-e1c3-ce2b-fe6a-88d45ad87383/AppIcon-0-1x_U007emarketing-0-7-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is3-ssl.mzstatic.com/image/thumb/Purple113/v4/06/e9/49/06e949ef-857f-f11a-15b5-88fd7a5024d8/AppIcon-0-1x_U007emarketing-0-5-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is5-ssl.mzstatic.com/image/thumb/Purple113/v4/7c/8e/4e/7c8e4e38-d671-3ac4-50c6-2a5dfa31e226/AppIcon-1x_U007emarketing-0-7-0-sRGB-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/24/e2/37/24e237fa-a674-10d9-329b-782e8d5290f1/AppIcon-1x_U007emarketing-0-10-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is5-ssl.mzstatic.com/image/thumb/Purple126/v4/f0/e5/8c/f0e58c0c-bb68-614d-76df-0c54e2979f7c/AppIcon-0-1x_U007emarketing-0-5-0-sRGB-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is1-ssl.mzstatic.com/image/thumb/Purple126/v4/77/d9/46/77d946ad-8425-1c77-91c2-e4874ed58bd1/AppIcon-0-1x_U007emarketing-0-7-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is4-ssl.mzstatic.com/image/thumb/Purple126/v4/0f/0d/6e/0f0d6e1f-64b2-abf4-e670-9c3044fbf9ca/AppIcon-0-1x_U007emarketing-0-6-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is2-ssl.mzstatic.com/image/thumb/Purple116/v4/81/1f/c0/811fc02a-2149-4cc3-97c8-c24f90f3e91e/AppIcon-1x_U007emarketing-0-10-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/2a/33/fa/2a33faaf-c63e-ad35-287c-614dcf8745ba/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/256x265bb.jpg",
  },
  {
    url: "https://is5-ssl.mzstatic.com/image/thumb/Purple116/v4/bf/58/24/bf5824c2-4f37-6008-d523-3986bd547312/AppIcon-0-1x_U007emarketing-0-5-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is1-ssl.mzstatic.com/image/thumb/Purple126/v4/33/bb/d3/33bbd3e1-c4e7-8e58-10bb-1e4f4e1fb16c/AppIcon-1x_U007emarketing-0-7-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is5-ssl.mzstatic.com/image/thumb/Purple126/v4/43/24/d8/4324d85d-2ea4-340b-316d-6608d6394889/AppIcon-production-1x_U007emarketing-0-7-0-sRGB-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is2-ssl.mzstatic.com/image/thumb/Purple126/v4/0f/3e/38/0f3e38d1-e233-fbec-3ef9-f6f2eb506888/AppIcon-1x_U007emarketing-0-7-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is2-ssl.mzstatic.com/image/thumb/Purple126/v4/4a/1b/42/4a1b426d-07d5-c465-e6db-b2cdae0451d0/AppIcon-0-1x_U007emarketing-0-10-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is4-ssl.mzstatic.com/image/thumb/Purple126/v4/a6/01/9f/a6019fd8-0d1c-456c-b748-d904b5fc4940/AppIcon-Release-0-1x_U007emarketing-0-7-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/82/73/db/8273db2a-406e-abc3-4156-8cfa827bfaf4/AppIcon-0-1x_U007emarketing-0-10-0-85-220.png/256x256bb.jpg",
  },
  {
    url: "https://is4-ssl.mzstatic.com/image/thumb/Purple123/v4/04/f3/12/04f31216-4b8e-af33-a816-fb8cb487349a/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/256x265bb.jpg",
  },
  {
    url: "https://is4-ssl.mzstatic.com/image/thumb/Purple126/v4/37/01/ea/3701ea0c-e255-480e-726b-5955756a5f82/AppIcon-0-0-1x_U007emarketing-0-7-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is2-ssl.mzstatic.com/image/thumb/Purple126/v4/e6/73/b4/e673b442-b258-9548-1ab0-56001930834e/AppIcon-0-1x_U007emarketing-0-10-0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is3-ssl.mzstatic.com/image/thumb/Purple116/v4/2b/f1/69/2bf169ae-f122-0e27-49cc-aeee4d48d9e2/AppIcon-0-1x_U007emarketing-0-0-0-7-0-0-GLES2_U002c0-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is5-ssl.mzstatic.com/image/thumb/Purple116/v4/0d/fd/b5/0dfdb5c9-2bc1-e6c9-8cae-5706b6439f0a/AppIcon-0-1x_U007emarketing-0-0-0-10-0-0-sRGB-85-220.png/256x265bb.jpg",
  },
  {
    url: "https://is3-ssl.mzstatic.com/image/thumb/Purple116/v4/5a/7d/37/5a7d3744-ba22-351f-cc55-35d3aa4a0926/AppIcon-0-1x_U007emarketing-0-7-0-85-220.png/256x265bb.jpg",
  },
]

export type Review = {
  author: string
  jobTitle: string
  company: string
  text: React.ReactNode
  website?: string
  imageUrl: string
}

const Sexy = tw.span`font-bold text-primary-500`

export const AllReviews: Array<Review> = [
  {
    author: "Bernard Bontemps",
    jobTitle: "Head of Growth",
    company: "Mojo",
    text: (
      <p>
        Thanks to Superwall, we were able to 2x our iOS app profitability in just six months. It has
        greatly assisted our growth team in achieving exceptional results by facilitating
        high-frequency experimentation.
      </p>
    ),
    website: "https://www.mojo-app.com/",
    imageUrl:
      "https://is2-ssl.mzstatic.com/image/thumb/Purple116/v4/93/41/d9/9341d9eb-3c70-b000-01c2-1985e2fd8714/AppIcon-AppStore-0-1x_U007emarketing-0-10-0-85-220.png/256x256bb.jpg",
  },
  {
    author: "Matthieu Rouif",
    jobTitle: "CEO",
    company: "Photoroom",
    text: (
      <p>
        Really excited about the progress we made recently on paywalls with Superwall. We got more
        than 50% increase in conversion for upsell screens. This is crazy.
      </p>
    ),
    website: "https://photoroom.com/",
    imageUrl:
      "https://is2-ssl.mzstatic.com/image/thumb/Purple116/v4/e6/ac/af/e6acaf67-e34e-c62d-b765-ea9525ed1d73/AppIcon-1x_U007emarketing-0-7-0-85-220.png/256x256bb.jpg",
  },
  {
    author: "Jordan Gaphni",
    jobTitle: "Head of Growth",
    company: "Pixite",
    text: (
      <p>
        Superwall is the single greatest tool we’ve used to help us increase our revenue. Our
        material wins from Superwall are greater than any tool we’ve worked with to date!
      </p>
    ),
    website: "https://www.pixiteapps.com/",
    imageUrl:
      "https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/09/46/d1/0946d117-56a7-dfc3-7f2c-9be428568852/AppIcon-0-1x_U007emarketing-0-7-0-85-220.png/256x256bb.jpg",
  },
  {
    author: "Jon Rhome",
    jobTitle: "Head of Product",
    company: "Citizen",
    text: (
      <p>
        Superwall lets us move 10x faster on our monetization strategy. We can build and launch
        multiple paywall iterations without the need for client releases or complicated deploys. Our
        product iteration loop is days, rather than months because of Superwall.
      </p>
    ),
    website: "https://citizen.com/",
    imageUrl:
      "https://is5-ssl.mzstatic.com/image/thumb/Purple116/v4/a5/8b/12/a58b123b-f09d-9e9b-5ccb-a47221b3e2de/AppIcon-1x_U007emarketing-0-7-0-85-220.png/256x265bb.jpg",
  },

  {
    author: "Vahe Baghdasaryan",
    jobTitle: "Sr. Growth",
    company: "Coinstats",
    text: (
      <p>
        Superwall has revolutionized our monetization strategy. It’s an essential tool that allows
        rapid paywall testing and optimization, leading to remarkable improvements in our
        subscription conversions and revenue generation. Can’t recommend Superwall enough for any
        app-based business.
      </p>
    ),
    website: "https://coinstats.app/",
    imageUrl:
      "https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/82/73/db/8273db2a-406e-abc3-4156-8cfa827bfaf4/AppIcon-0-1x_U007emarketing-0-10-0-85-220.png/512x512bb.jpg",
  },
  {
    author: "Seth Miller",
    jobTitle: "CEO",
    company: "RapChat",
    text: (
      <p>
        Superwall has completely changed the game for us. We’re able to run experiments 10x faster
        and unlock the ideal monetization model for our users.
      </p>
    ),
    website: "https://rapchat.com/",
    imageUrl:
      "https://is2-ssl.mzstatic.com/image/thumb/Purple116/v4/81/1f/c0/811fc02a-2149-4cc3-97c8-c24f90f3e91e/AppIcon-1x_U007emarketing-0-10-0-85-220.png/256x256bb.jpg",
  },

  {
    author: "Chris Heinrich",
    jobTitle: "CEO",
    company: "Polycam",
    text: (
      <p>
        Shout out to Superwall for helping us dial in our paywall — made a big impact on
        monetization, increasing revenue by more than 50% 💸
      </p>
    ),
    website: "https://poly.cam/",
    imageUrl:
      "https://is3-ssl.mzstatic.com/image/thumb/Purple126/v4/47/0c/98/470c98d9-e533-350d-e58d-6b26f22d760b/AppIcon-1x_U007emarketing-0-7-0-85-220.png/256x256bb.jpg",
  },
  {
    author: "Chris Bick",
    jobTitle: "CEO",
    company: "Bickster",
    text: (
      <p>
        Superwall enables Bickster&rsquo;s marketing team to design and optimize app paywalls,
        freeing up engineering to concentrate on innovation. As a result, Superwall helped
        accelerate our install-to-subscription rates, lower engineering expenses, and cured our
        team&rsquo;s frustration with the (once) time-consuming process of iterating on paywalls.
      </p>
    ),
    website: "https://www.bickster.com/",
    imageUrl:
      "https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/40/5f/63/405f632b-2748-9fb4-9805-e3d563439928/AppIcon-1x_U007emarketing-0-5-0-85-220.png/100x100bb.jpg",
  },
  {
    author: "Nils Breitmar",
    jobTitle: "Head of Growth",
    company: "Hornet",
    text: (
      <p>
        Superwall has played an integral part of improving our subscription business. Compared to
        other providers, Superwall has proven superior in facilitating high-frequency
        experimentation allowing us to achieve an ideal monetization model, resulting in a
        significant increase in revenue.
      </p>
    ),
    website: "https://hornet.com/",
    imageUrl:
      "https://is5-ssl.mzstatic.com/image/thumb/Purple126/v4/43/24/d8/4324d85d-2ea4-340b-316d-6608d6394889/AppIcon-production-1x_U007emarketing-0-7-0-sRGB-85-220.png/256x256bb.jpg",
  },
  {
    author: "Mate Kovacs",
    jobTitle: "Indie Dev",
    company: "Teleprompter",
    text: (
      <p>
        Superwall made testing paywalls so much faster. Instead of releasing a new version of the
        app each time, we were able to iterate on the winning paywalls much quicker. Thanks to that
        it increased our revenue per customer by 40%.
      </p>
    ),
    website: "http://teleprompter.com/",
    imageUrl:
      "https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/2a/33/fa/2a33faaf-c63e-ad35-287c-614dcf8745ba/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/256x256bb.jpg",
  },

  {
    author: "Zach Shakked",
    jobTitle: "Founder",
    company: "Hashtag Expert",
    text: (
      <p>
        Superwall increases revenue. Full stop. Being able to test paywalls on the fly and quickly
        analyze results has drastically increased our revenue and improved our monetization of
        users. Highly recommend this tool!
      </p>
    ),
    website: "https://www.hashtag.expert/",
    imageUrl:
      "https://is3-ssl.mzstatic.com/image/thumb/Purple113/v4/06/e9/49/06e949ef-857f-f11a-15b5-88fd7a5024d8/AppIcon-0-1x_U007emarketing-0-5-0-85-220.png/256x256bb.jpg",
  },
]
